// src/constants.ts
var defaultTolerance = 75e-4;
var defaultOptions = {
  vulgarFractions: false,
  tolerance: defaultTolerance,
  fractionSlash: false,
  romanNumerals: false
};
var vulgarToAsciiMap = {
  "\xBC": "1/4",
  "\xBD": "1/2",
  "\xBE": "3/4",
  "\u2150": "1/7",
  "\u2151": "1/9",
  "\u2152": "1/10",
  "\u2153": "1/3",
  "\u2154": "2/3",
  "\u2155": "1/5",
  "\u2156": "2/5",
  "\u2157": "3/5",
  "\u2158": "4/5",
  "\u2159": "1/6",
  "\u215A": "5/6",
  "\u215B": "1/8",
  "\u215C": "3/8",
  "\u215D": "5/8",
  "\u215E": "7/8"
};
var fractionDecimalMatches = [
  [0.33, "\u2153"],
  [0.66, "\u2154"],
  [0.2, "\u2155"],
  [0.4, "\u2156"],
  [0.6, "\u2157"],
  [0.8, "\u2158"],
  [0.166, "\u2159"],
  [0.833, "\u215A"],
  [0.143, "\u2150"],
  [0.111, "\u2151"],
  [0.1, "\u2152"],
  [0.125, "\u215B"],
  [0.25, "\xBC"],
  [0.375, "\u215C"],
  [0.5, "\xBD"],
  [0.625, "\u215D"],
  [0.75, "\xBE"],
  [0.875, "\u215E"],
  [0.0625, "1/16"],
  [0.1875, "3/16"],
  [0.3125, "5/16"],
  [0.4375, "7/16"],
  [0.5625, "9/16"],
  [0.6875, "11/16"],
  [0.8125, "13/16"],
  [0.9375, "15/16"]
];

// src/formatQuantity.ts
var closeEnough = (n1, n2, tolerance) => Math.abs(n1 - n2) < tolerance;
var getFraction = (vulgarFractionOrSixteenth, { fractionSlash, vulgarFractions }) => {
  if (vulgarFractions) {
    return vulgarFractionOrSixteenth;
  }
  const plainFraction = vulgarToAsciiMap[vulgarFractionOrSixteenth] ?? vulgarFractionOrSixteenth;
  if (fractionSlash) {
    return plainFraction.replace("/", "\u2044");
  }
  return plainFraction;
};
var normalizeOptions = (options) => ({
  ...defaultOptions,
  ...typeof options === "boolean" ? { vulgarFractions: options } : options
});
var romanNumeralValueKey = [
  "",
  "C",
  "CC",
  "CCC",
  "CD",
  "D",
  "DC",
  "DCC",
  "DCCC",
  "CM",
  "",
  "X",
  "XX",
  "XXX",
  "XL",
  "L",
  "LX",
  "LXX",
  "LXXX",
  "XC",
  "",
  "I",
  "II",
  "III",
  "IV",
  "V",
  "VI",
  "VII",
  "VIII",
  "IX"
];
var formatRomanNumerals = (qty) => {
  if (typeof qty !== "number" || isNaN(qty)) {
    return null;
  }
  if (qty < 1 || qty >= 4e3) {
    return "";
  }
  const floored = Math.floor(qty);
  const digits = `${floored}`.split("");
  let roman = "";
  let i = 3;
  while (i--) {
    roman = `${romanNumeralValueKey[+digits.pop() + i * 10] || ""}${roman}`;
  }
  return `${Array(+digits.join("") + 1).join("M")}${roman}`;
};
var formatQuantity = (qty, options = defaultOptions) => {
  const qtyAsNumber = typeof qty === "string" ? parseFloat(qty) : qty;
  if (isNaN(qtyAsNumber) || qtyAsNumber === null) {
    return null;
  }
  if (qtyAsNumber === 0) {
    return "";
  }
  const opts = normalizeOptions(options ?? defaultOptions);
  if (opts.romanNumerals) {
    return formatRomanNumerals(qtyAsNumber);
  }
  const absoluteValue = Math.abs(qtyAsNumber);
  const flooredAbsVal = Math.floor(absoluteValue);
  const flooredAbsValStr = `${qtyAsNumber < 0 ? "-" : ""}${flooredAbsVal === 0 ? "" : `${flooredAbsVal} `}`;
  const decimalValue = absoluteValue - flooredAbsVal;
  if (decimalValue === 0) {
    return `${qtyAsNumber}`;
  }
  for (const [num, vf] of fractionDecimalMatches) {
    if (closeEnough(decimalValue, num, opts.tolerance)) {
      const fraction = getFraction(vf, opts);
      const int = fraction in vulgarToAsciiMap ? flooredAbsValStr.trim() : flooredAbsValStr;
      return `${int}${fraction}`;
    }
  }
  return `${qtyAsNumber}`;
};
export {
  defaultOptions,
  defaultTolerance,
  formatQuantity,
  fractionDecimalMatches,
  vulgarToAsciiMap
};
//# sourceMappingURL=format-quantity.mjs.map